module.exports = __webpack_public_path__ + "img/default-event.f3f49b19.jpg";